import { render, staticRenderFns } from "./RecruitmentTection.vue?vue&type=template&id=21205052&scoped=true"
import script from "./RecruitmentTection.vue?vue&type=script&lang=js"
export * from "./RecruitmentTection.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentTection.vue?vue&type=style&index=0&id=21205052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21205052",
  null
  
)

export default component.exports